import FeatureGates from '@atlaskit/feature-gate-js-client';
import { type SurfaceMetadata } from '@atlassian/ai-smart-button-api';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { ObjectSidebar } from '../types/object-sidebar-types';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { AISmartButtonSidebarAPI } from '../types/shared-types';

export const isObjectSidebar = (
	sidebarApi: AISmartButtonSidebarAPI | ObjectSidebar,
): sidebarApi is ObjectSidebar => {
	return (
		'state' in sidebarApi && 'actions' in sidebarApi && 'changeHeaderElements' in sidebarApi.actions
	);
};

export const handleConvoStarters = (
	surfaceMetadata: SurfaceMetadata,
	setShowConvoStarters: (show: boolean) => void,
) => {
	if (surfaceMetadata.product === 'confluence') {
		setShowConvoStarters(
			FeatureGates.getExperimentValue(
				'contextual_convo_starters_in_rovo_button_panel',
				'isEnabled',
				false,
			),
		);
	} else {
		setShowConvoStarters(false);
	}
};
